// extracted by mini-css-extract-plugin
export default {"container":"perfil_container__strBQ","avatar":"perfil_avatar__UOSwA","info":"perfil_info__ymFnJ","nome":"perfil_nome__4Cj0g","tipo":"perfil_tipo__xCxY2"};